<template lang="pug">
  .side-container__content
    .side-container__header(v-if="asideData.title || asideData.subtitle")
      p.side-container__title.-dark-(v-if="asideData.title")
        | {{asideData.title}}
      p.side-container__subtitle(v-if="asideData.subtitle")
        | {{asideData.subtitle}}
    .side-container__body.-full-
      .side-container-field
        .side-container-field__list
          .side-container-field__item
            UiInput(
              v-model="team.name"
              title='Название'
              placeholder="Напишите название команды"

              :popup="validPopup(!$v.team.name.required, 'Обязательное поле')"
            )
          .side-container-field__item
            UiSelectFilter(
              v-model="team.folder"

              title='Группа'
              placeholder="Укажите группу"

              :maxHeight="200"
              :option="groupList"
              :popup="validPopup(!$v.team.folder.required, 'Обязательное поле')"
            )
          .side-container-field__item
            UiSelectFilter(
              v-model="team.captain"

              title='Капитан'
              placeholder="Укажите капитана"

              :canUnset="true"
              unsetText="Без капитана"
              unsetClass=""
              :maxHeight="200"
              :option="captainList"
            )
          .side-container-field__item
            UiSelectFilter(
              v-model="team.seniorCaptain"

              title='Старший капитан'
              placeholder="Укажите старшего капитана"

              :canUnset="true"
              unsetText="Без старшего капитана"
              unsetClass=""
              :maxHeight="200"
              :option="seniorCaptainList"
            )
    .side-container__footer.-end-
      UiButton(
        @click="createTeam"
      ) Сохранить

</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    asideObject: {
      type: Object,
      default: () => ({
        aside: {
          data: {},
          meta: {}
        }
      })
    }
  },
  data: () => ({
    team: {
      name: '',
      folder: null,
      captain: null,
      seniorCaptain: null
    }
  }),
  computed: {
    asideData() {
      return this.asideObject.aside ? this.asideObject.aside.data : {};
    },
    asideMeta() {
      return this.asideObject.aside ? this.asideObject.aside.meta : {};
    },
    ...mapState('teamGroup', {
      groupList: s =>
        s.data.allGroups.map(group => ({
          value: group.id,
          title: group.name
        })),
      settings: s => s.data.settings,
      captainList: s =>
        s.data.settings.captains.map(item => ({
          value: item.id,
          title: `${item.name} ${item.lastname}`
        })),
      seniorCaptainList: s =>
        s.data.settings.seniorCaptains.map(item => ({
          value: item.id,
          title: `${item.name} ${item.lastname}`
        }))
    })
  },
  mounted() {
    this.$store.dispatch('teamGroup/getAllGroups');
  },
  methods: {
    ...mapActions('asides', ['closeAside', 'updateAsideMetaPath']),
    async createTeam() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.showLoader();
      const res = await this.$store.dispatch('teamGroup/createTeam', this.team);

      if (res.status === 'success') {
        await this.$store.dispatch('teamGroup/getTeamGroupData');
        this.closeAside({ name: this.asideObject.aside.data.name });
      }

      this.unshowLoader();
    },
    validPopup(isErr, text) {
      if (!this.$v.$dirty) {
        return;
      }
      if (isErr) {
        return { msg: text, error: true };
      }
    },
    showLoader() {
      this.updateAsideMetaPath({
        asideIndex: this.asideObject.asideIndex,
        path: 'showLoader',
        value: true
      });
    },
    unshowLoader() {
      this.updateAsideMetaPath({
        asideIndex: this.asideObject.asideIndex,
        path: 'showLoader',
        value: false
      });
    }
  },
  validations: {
    team: {
      name: { required },
      folder: { required }
    }
  }
};
</script>
